module.exports = __webpack_public_path__ + "static/media/ss12_preview.50a38f60.jpg";